// TelcoTrack — photo thumbs for activity / history rows (IDs → download URLs).

export interface ActivityPhotoThumb {
  id: string;
  url: string;
  description?: string;
}

/** Build thumbnail models from history `photoIds` (no extra API — same URL as object timeline). */
export function activityPhotosFromIds(photoIds: unknown): ActivityPhotoThumb[] {
  if (!Array.isArray(photoIds) || photoIds.length === 0) return [];
  const out: ActivityPhotoThumb[] = [];
  const seen = new Set<string>();
  for (const raw of photoIds) {
    const id = String(raw ?? '').trim();
    if (!id || seen.has(id)) continue;
    seen.add(id);
    out.push({ id, url: `/api/objects/photos/${encodeURIComponent(id)}/download` });
  }
  return out;
}
